import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "div .Tabs_inactive__H0mPh{display:none}";
var S = {"inactive":"Tabs_inactive__H0mPh"};
styleInject(css_248z);

export { S as default };
